import { useContext } from 'react';
import LocaleContext from '../../contexts/LocaleContext';
import './JonesFooter.scss';
import getText from '../../assets/locale/locale';

/**
 * JonesFooter is the EJ Footer consistent across all screens and customized for US or Canadian users
 */
const JonesFooter = () => {
  const locId = useContext(LocaleContext);

  const handleCopyrightText = () => {
    const component = locId === 'en_US' ? 'copyrightParagraph' : 'line2';
    return getText(locId, component, 'footer').replace(
      '%CURRENT_YEAR%',
      new Date().getFullYear().toString()
    );
  };

  return (
    <footer role="contentinfo" id="footerBox" data-testid="jonesFooter">
      {locId === 'en_US' ? (
        <div className="footerContainer">
          <div className="links">
            <a
              href={getText(locId, 'careersLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'careersText', 'footer')}
            </a>
            <a
              href={getText(locId, 'personalFinanceLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'personalFinanceText', 'footer')}
            </a>
            <a
              href={getText(locId, 'feedbackLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'feedbackText', 'footer')}
            </a>
            <a
              href={getText(locId, 'privacyLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'privacyText', 'footer')}
            </a>
            <a
              href={getText(locId, 'revenueSharingLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'revenueSharingText', 'footer')}
            </a>
            <a
              href={getText(locId, 'formCrsLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'formCrsText', 'footer')}
            </a>
            <a
              href={getText(locId, 'disclosuresLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'disclosuresText', 'footer')}
            </a>
            <a
              href={getText(locId, 'accessibilityLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'accessibilityText', 'footer')}
            </a>
          </div>
          <div className="footerContent">
            <p>
              {handleCopyrightText()}
              <a
                title={getText(locId, 'sipcText', 'footer')}
                className="copyrightLink"
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'sipcLink', 'footer')}
              >
                {getText(locId, 'sipcText', 'footer')}
              </a>
              .
              <br />
              {getText(locId, 'disclaimerParagraph', 'footer')}
            </p>
          </div>
        </div>
      ) : (
        <div className="footerContainer">
          <div className="links">
            <a
              href={getText(locId, 'careersLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'careersText', 'footer')}
            </a>
            <a
              href={getText(locId, 'feedbackLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'feedbackText', 'footer')}
            </a>
            <a
              href={getText(locId, 'privacyLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'privacyText', 'footer')}
            </a>
            <a
              href={getText(locId, 'disclosuresLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'disclosuresText', 'footer')}
            </a>
            <a
              href={getText(locId, 'accessibilityLink', 'footer')}
              target="_blank"
              rel="noopener noreferrer"
            >
              {getText(locId, 'accessibilityText', 'footer')}
            </a>
          </div>
          <div className="footerContent">
            <p>
              {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
              {getText(locId, 'member', 'footer')}
              <a
                title={getText(locId, 'CIPFText', 'footer')}
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'CIPFLink', 'footer')}
              >
                {getText(locId, 'CIPFText', 'footer')}
              </a>
              {getText(locId, 'member2', 'footer')}
              <a
                title={getText(locId, 'IIROCText', 'footer')}
                target="_blank"
                rel="noopener noreferrer"
                href={getText(locId, 'IIROCLink', 'footer')}
              >
                {getText(locId, 'IIROCText', 'footer')}
              </a>
              .
            </p>
            <p>{getText(locId, 'line1', 'footer')}</p>
            <p>{handleCopyrightText()}</p>
            <p>{getText(locId, 'line3', 'footer')}</p>
            <p>{getText(locId, 'line4', 'footer')}</p>
            <p>{getText(locId, 'line5', 'footer')}</p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default JonesFooter;
